createHashHistory